const locale = {
	VIEW_OPPORTUNITIES_TAB_KANBAN: 'Kanban',

	// #region Opportunities fields
	DETAILS_OPPORTUNITIES_FIELD_TITLE: 'Title',
	DETAILS_OPPORTUNITIES_FIELD_STATUS: 'Opportunity Status',
	DETAILS_OPPORTUNITIES_FIELD_TYPE: 'Opportunity Type',
	DETAILS_OPPORTUNITIES_FIELD_COMPANY: 'Company',
	DETAILS_OPPORTUNITIES_FIELD_PERSON: 'External Reference',
	DETAILS_OPPORTUNITIES_FIELD_ASSIGNED_USER: 'Internal assigned User',
	DETAILS_OPPORTUNITIES_FIELD_ASSIGNED_USER_2: 'External assigned User',
	DETAILS_OPPORTUNITIES_FIELD_DATE_FROM: 'Start date',
	DETAILS_OPPORTUNITIES_FIELD_DATE_TO: 'End date',
	DETAILS_OPPORTUNITIES_FIELD_RATING: 'Rating',
	DETAILS_OPPORTUNITIES_FIELD_PLANNEDVALUE: 'Planned value',
	DETAILS_OPPORTUNITIES_FIELD_EXPENSES: 'Expenses',
	DETAILS_OPPORTUNITIES_FIELD_TAGS: 'Tags',
	DETAILS_OPPORTUNITIES_FIELD_WARNING: 'Warning',
	DETAILS_OPPORTUNITIES_FIELD_BLOCKED: 'Blocked'
	// DETAILS_OPPORTUNITIES_FIELD_CLOSEDATE: 'Close Date',
	// #endregion
};

export default locale;
